import {FC, memo} from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import DefaultThemeOptions from 'config/theme';

import ImageLoader, {ImageLoaderProps} from '../image-loader';
import {RightRibbonContainer, RightRibbonIconHolder, RightRibbonWrapper} from './styles';
import {RightRibbonProps} from './types';

export const Component: FC<RightRibbonProps> = ({
  rightRibbonInfo,
  isSlabPrice,
  iconSize,
  className = '',
  removeImageSkeleton
}) => {
  const theme = DefaultThemeOptions;
  const isMobile = useMediaQuery(theme.breakpoints.only('mobile'));

  const imageProps: ImageLoaderProps = {
    image: {
      src: '',
      alt: '',
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      quality: 100,
      layout: 'fixed',
      ...(iconSize || {})
    },
    skelton: {
      width: isMobile ? 38 : 48,
      height: isMobile ? 38 : 48,
      variant: 'rounded',
      ...(iconSize || {})
    }
  };
  if (rightRibbonInfo.length <= 0 && !isSlabPrice) {
    return <></>;
  }

  return (
    <RightRibbonContainer className={className}>
      <RightRibbonWrapper className={className}>
        {rightRibbonInfo?.length > 0 &&
          rightRibbonInfo.map((el, index) => {
            return (
              <RightRibbonIconHolder
                key={el.id}
                className={!isSlabPrice && index === 0 ? className : `dynamic-image ${className}`}
              >
                <ImageLoader
                  key={el.id}
                  removeImageSkeleton={removeImageSkeleton}
                  className="right-ribbon"
                  {...{...imageProps, image: {...imageProps.image, src: el?.imageUrl || ''}}}
                />
              </RightRibbonIconHolder>
            );
          })}
      </RightRibbonWrapper>
    </RightRibbonContainer>
  );
};

export const RightRibbon = memo(Component, () => true);
